export const BASE_URL = "https://app.rasutrip.com/api/v1";

export const STATUS_COLORS = {
  Approved:    { bg: "#d1fae5", text: "#065f46", dot: "#10b981" },
  Pending:     { bg: "#fef3c7", text: "#92400e", dot: "#f59e0b" },
  Closed:      { bg: "#f1f5f9", text: "#475569", dot: "#94a3b8" },
  Rejected:    { bg: "#fee2e2", text: "#991b1b", dot: "#ef4444" },
  Shortlisted: { bg: "#dbeafe", text: "#1e40af", dot: "#3b82f6" },
  Hired:       { bg: "#d1fae5", text: "#065f46", dot: "#10b981" },
};